import { messageComponent } from "../../../components/message/message.component";
import masterConfigurationModel from "../../../models/config-master.model";
import ViewBase from "../../view-base.view";
import MasterConfigurationView from "./master-configuration-master.view";
import MasterDetailsEditView from "./master-details-edit.view";


export default function MasterDetailsMainView() {
    ViewBase.call(this);
    let isEditView = false;
    let selectedData = "";
    let isAuthorized = true;
    let isMsgOpen = false;
    let showMsg = "";
    let msgTitle = "";
    let _checkAuthorization = () => {


        masterConfigurationModel.checkAuthorization(
            (result) => {
                if (result[0].code == "EM00000004") {
                    isAuthorized = true;
                    isMsgOpen = false;
                    showMsg = "";
                    msgTitle = "";
                }
                else {
                    isAuthorized = false;
                    isMsgOpen = true;
                    showMsg = result[0].message;
                    msgTitle = this.getText("LT00000562", "Unauthorized");
                }
            },
            (error) => {
                this.handleError(error);
            }
        )
    }
    return {
        oninit: function (vnode) {
            _checkAuthorization();
        },

        view: (vnode) => {
            return [
                (isAuthorized && !isEditView) && m(MasterConfigurationView, { 
                    onChange: (data) => { isEditView = true; selectedData = data } 
                }),
                (isAuthorized && isEditView) && m(MasterDetailsEditView, { 
                    onChange: () => { isEditView = false, selectedData = ""; }, data: selectedData 
                }),
                m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: () => { isMsgOpen = false } })
            ];
        }
    }
}
